<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-type-none element-with-heading" id="praise-for-divine-poison">
<div class="heading heading-with-title heading-without-image" id="praise-for-divine-poison-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Praise for Divine Poison:</h1>
</div>
</div>
</div>
</div>
<div class="text" id="praise-for-divine-poison-text">
<p class="first first-in-chapter first-full-width"><span class="first-phrase"><span class="drop-cap"><span class="first-punctuation">"</span>T</span>he pace is</span> great for the plot, which is well thought out and planned thoroughly to give it an added edge..."<b> <i>Donna Maguire - Donnas Book <span class="last-word">Blog</span></i></b></p>
<p class="subsq">"I would highly recommend this book to so many readers. And I’m definitely going to be reading so much more by this author." <b><i>Ami-May Smith - Shyla's Uncensored <span class="last-word">Opinions</span></i></b></p>
<p class="subsq">"This story was full of intrigue and mystery that kept me turning page after page.<b>" <i>Lorna Cassidy - On The Shelf <span class="last-word">Reviews</span></i></b></p>
<p class="subsq">"Divine Poison has a tangled web of lies and secrets lurking within the pages along with a few surprises thrown in to make things interesting." <i>Rachel Broughton - Rae <span class="last-word">Reads</span></i></p>
<p class="subsq">"DIVINE POISON is thrilling to read and a book to keep you on your toes!"<b> <i>Sooz Barthorpe - The P.Turners Book <span class="last-word">Blog</span></i></b></p>
<p class="subsq">"Again AB Morgan has used her own career experiences to add her own unique style to this story." <b><i>Yvonne Bastian - Me And My <span class="last-word">Books</span></i></b></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// praisefordivinepoison.vue?55165ea6